import React, { Component } from 'react';
import CreateIcon from '@mui/icons-material/Create';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import WithRouter from 'custom/withRouter';
import Button from 'screens/components/basic/Button';

class Header extends Component {
  renderOptionalField(label, value) {
    return value ? <h5 className="view-description"><span>{label}: </span>{value}</h5> : null;
  }

  render() {
    const { product, printLabel, isMedical, handleDeleteProduct, saveToPDF, allAccess } = this.props;

    if (!product) return null;

    const {
      urlImage,
      name,
      isElite,
      category,
      sku,
      brand,
      subCategoryName,
      subsubCategory,
      webName,
      abSuggestedPrice,
      bcSuggestedPrice,
      onSuggestedPrice,
      mbSuggestedPrice,
      skSuggestedPrice,
      thC_Range,
      cbD_Range,
      complianceUPC,
      complianceCategory,
      size,
      description,
      priceMatrixId,
      price,
      status,
      id,
    } = product;

    return (
      <div className="text-center p-0 row">
        <div className="container-img-container text-center col-md-4">
          <div className="product-img-container" 
            style={{ 
              backgroundImage: `url(${urlImage ? urlImage : `http://techpos.ca/mailing/noimage.png`})`,
              backgroundSize: `${urlImage ? `cover` : 'auto'}`
            }} 
            id={`${name} image`} />
        </div>
        {/* Product Info and Menu */}
        <div className="view-btn-container">
          <Button
            newClass="view-edit-btn"
            type="IconRemove"
            icon={<CreateIcon />}
            label="Edit"
            onTouchTap={() => this.props.navigate(`/product/edit/${id}`)}
            disabled={!allAccess}
          />
          <Button
            newClass="view-delete-btn"
            type="IconRemove"
            icon={<HighlightOffIcon />}
            label="Delete"
            onTouchTap={() => handleDeleteProduct(id)}
            disabled={!allAccess}
          />
        </div>
        <div className="profile-view-lis product-details-header-context col-lg-8 col-md-8 col-sm-8 col-xs-12 text-left">
            <h2 className="view-title mt-5">{product.name}</h2>
            {
              product.isElite && <h4 className="view-subtitle mb-0 mt-0 red-color">Elite Product</h4>
            }
            <h4 className="view-subtitle mb-2 mt-0">{product.category}</h4>
            <h5 className="view-description mt-0">SKU: <span>{product.sku}</span></h5>
            {product.brand ? <h5 className="view-description mt-0">Brand: <span>{product.brand}</span></h5> : ""}
            {product.subCategoryName ? <h5 className="view-description mt-0">Sub Category: <span>{product.subCategoryName}</span></h5> : ""}
            {product.subsubCategory ? <h5 className="view-description mt-0">Sub Sub Category: <span>{product.subsubCategory}</span></h5> : ""}
            {product.webName ? <h5 className="view-description mt-0">Web Name: <span>{product.webName}</span></h5> : ""}
            {product.abSuggestedPrice ? <h5 className="view-description mt-0">AB Suggested Price: <span>{product.abSuggestedPrice}</span></h5> : ""}
            {product.bcSuggestedPrice ? <h5 className="view-description mt-0">BC Suggested Price: <span>{product.bcSuggestedPrice}</span></h5> : ""}
            {product.onSuggestedPrice ? <h5 className="view-description mt-0">ON Suggested Price: <span>{product.onSuggestedPrice}</span></h5> : ""}
            {product.mbSuggestedPrice ? <h5 className="view-description mt-0">MB Suggested Price: <span>{product.mbSuggestedPrice}</span></h5> : ""}
            {product.skSuggestedPrice ? <h5 className="view-description mt-0">SK Suggested Price: <span>{product.skSuggestedPrice}</span></h5> : ""}
            {product.thC_Range ? <h5 className="view-description mt-0">THC Range: <span>{product.thC_Range}</span></h5> : ""}
            {product.cbD_Range ? <h5 className="view-description mt-0">CBD Range: <span>{product.cbD_Range}</span></h5> : ""}
            {product.complianceUPC ? <h5 className="view-description mt-0">Compliance UPC: <span>{product.complianceUPC}</span></h5> : ""}
            {product.complianceCategory ? <h5 className="view-description mt-0">Compliance Category: <span>{product.complianceCategory}</span></h5> : ""}
            {product.size ? <h5 className="view-description mt-0">Size: <span>{product.size}</span></h5> : ""}
            {product.description ? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12"><p className="view-description mt-2">{product.description}</p></div> : null}
            <div className='row align-items-center pt-3' >
              <div className="p-0 col-lg-3 col-md-4 col-sm-12 col-xs-12 ">
                <h5 className="view-description">Price:</h5>
                <p className="view-main-info green-text">{!isMedical && product.priceMatrixId == 0 ? product.price.split('/')[0] : product.price}</p>
                <span className="subscript">{product.priceMatrixId == 0 && isMedical ? "Price / Member Price" : ""}</span>
              </div>
              <div className="col-lg-5 col-md-4 col-sm-6 col-xs-6">
                {product.type === "Unit" ?
                  <Button className="printBtn text-left"
                    type="PrintButton"
                    label="Print by Label"
                    onTouchTap={() => printLabel('Z' + (`00000000000${product.id}`).slice(-11), 1, product.price)}
                  />
                  :
                  <Button className="printBtn text-left"
                    type="PrintButton"
                    label="Print by Label"
                    onTouchTap={() => printLabel('Z' + (`00000000000${product.id}`).slice(-11), product.price)}
                  />
                }
                <br />
                <Button className="printBtn text-left"
                  type="SaveToPDFButton"
                  label="Save Label To PDF"
                  onTouchTap={() => saveToPDF('Z' + (`00000000000${product.id}`).slice(-11))}
                />
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6 col-xs-6 p-0 text-left pt-2">
                {product.status !== "Active" ? <p className="statusIconRed font-weight-bold">{product.status}</p> :
                  <p className="statusIconGreen font-weight-bold">{product.status}</p>
                }
              </div>
            </div>
        </div>
      </div>
    );
  }
}

export default WithRouter(Header);